import {type ReactNode} from "react";

interface PageContentProps {
    children: ReactNode;
    className?: string;
}

export const PageContent = ({children, className}: PageContentProps) => {
    return (
        <div className={`h-100 w-100 overflow-auto ps-2 ps-sm-4 pe-0 pe-sm-4${className ? ` ${className}` : ""}`}>
            {children}
        </div>
    );
};
